<template>
  <div
    @click="$emit('close')"
    class="pc-cart-guide"
  >
    <div class="select-here">
      <img
        src="@/assets/order/cart-checked.svg"
        width="20px"
        alt=""
      >
      <div class="select-all">
        Select all items
      </div>
      <div class="line" />
      <div class="delete">
        Delete Selected items
      </div>
    </div>
    <div class="check-here">
      <img
        src="@/assets/order/guide-checked.svg"
        width="20px"
        alt=""
      >
      <div class="check-tip">
        <div class="inner">
          <TipArrow class="tip-arrow" />
          <div class="tip">
            Click here to select items you want to add to checkout or delete.
          </div>
          <div class="footer">
            <div class="skip">
              Skip
            </div>
            <div class="got-it">
              Got it
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="checkout">
      Checkout
    </div>
  </div>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue'
import TipArrow from '@/components/TipArrow/index.vue'

onMounted(() => {
  document.documentElement.scrollTop = 0
  document.body.style.overflow = 'hidden'
})

onUnmounted(() => {
  document.body.style.overflow = ''
})
</script>

<style lang='less' scoped>
.pc-cart-guide {
  position: absolute;
  inset: 0;
  z-index: 999;

  .select-here {
    position: absolute;
    left: 850px;
    top: 66px;
    transform: translateX(-100%);
    display: flex;
    align-items: center;
    .select-all {
      margin-left: 8px;
      color: white;
      font-size: 12px;
      font-family: mon-500;
    }
    .line {
      height: 12px;
      width: 0.5px;
      background-color: #e4e6eb;
      margin: 0 12px;
    }
    .delete {
      color: white;
      font-size: 12px;
      font-family: mon-500;
    }
  }

  .check-here {
    position: absolute;
    top: 186px;
    left: 0;
    overflow: hidden;
    .check-tip {
      width: 313px;
      .inner {
        position: relative;
        margin-top: 8px;
        padding: 24px 16px 16px;
        background-color: rgba(80, 115, 240);
        border-radius: 4px;
        .tip-arrow {
          position: absolute;
          top: -17px;
          left: 5px;
        }
        .tip {
          color: white;
          font-size: 12px;
          font-family: mon-500;
          line-height: 16px;
        }
        .footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 16px;
          .skip {
            color: white;
            font-size: 14px;
            font-family: mon-600;
            cursor: pointer;
          }
          .got-it {
            width: 88px;
            height: 36px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #232323;
            border-radius: 20px;
            color: white;
            font-size: 14px;
            font-family: mon-600;
            cursor: pointer;
          }
        }
      }
    }
  }

  .checkout {
    position: absolute;
    right: 16px;
    top: 130px;
    width: 254px;
    height: 36px;
    border-radius: 20px;
    background: #4681f9;
    color: white;
    font-size: 14px;
    font-family: mon-600;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
